export default __webpack_public_path__ + "static/media/img-stack-for-value-mobile.1db3a2de.png";